import { Position } from "./models";

export const STARTING_POSITIONS: Record<string, Position> = {
    "Initial position": {
        name: "Initial position",
        fen: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
        defaultPlayerColor: "w",
        id: -1,
        standard: true,
        rating: 1200,
        startRating: 1200,
    },
    "Initial position (black)": {
        name: "Initial position",
        fen: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
        defaultPlayerColor: "b",
        id: -2,
        standard: true,
        rating: 1200,
        startRating: 1200,
    },
    // "Ruy lopez": {
    //     name: "Ruy lopez",
    //     fen: "r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 3 3",
    //     defaultPlayerColor: "w",
    //     standard: true,
    // },
    // "Fried liver": {
    //     name: "Fried liver",
    //     fen: "r1bqkb1r/ppp2ppp/2n5/3np1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - 0 6",
    //     defaultPlayerColor: "w",
    //     standard: true,
    // },
    // "Sicilian defence": {
    //     name: "Sicilian defence",
    //     fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2",
    //     defaultPlayerColor: "b",
    //     standard: true,
    // },
    // "Stafford gambit": {
    //     name: "Stafford gambit",
    //     fen: "r1bqkb1r/pppp1ppp/2n2n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - 1 4",
    //     defaultPlayerColor: "b",
    //     standard: true,
    // },
    "Custom position": {
        name: "Custom position",
        fen: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
    },
};

export const INITIAL_POSITIONS = [
    {
        name: "Initial position",
        fen: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
        defaultPlayerColor: "w",
        id: -1,
        standard: true,
    },
    {
        name: "Initial position",
        fen: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
        defaultPlayerColor: "b",
        id: -2,
        standard: true,
    },
];
